import 'react-native-gesture-handler';
import React, { useEffect } from 'react';
import { StatusBar, StyleSheet, View, Platform, Text } from 'react-native';
import { NavigationContainer, DarkTheme } from '@react-navigation/native';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { RootNavigator } from './src/navigation/RootNavigator';
import { ToastProvider } from './src/components/common';

const App: React.FC = () => {
  useEffect(() => {
    if (Platform.OS === 'web') {
      const style = document.createElement('style');
      style.textContent = `
        html, body, #root {
          height: 100vh;
          width: 100vw;
          overflow: hidden;
          margin: 0;
          padding: 0;
          position: fixed;
          background-color: #000;
          overscroll-behavior-y: none;
        }
      `;
      document.head.append(style);
    }
  }, []);

  return (
    <SafeAreaProvider style={styles.container}>
      <ToastProvider>
        <NavigationContainer theme={DarkTheme}>
          <StatusBar barStyle="light-content" backgroundColor="#000" />
          <RootNavigator />
        </NavigationContainer>
      </ToastProvider>
    </SafeAreaProvider>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#000',
    ...Platform.select({
      web: {
        height: '100vh',
        width: '100vw',
        overflow: 'hidden',
        position: 'fixed',
      } as any,
    }),
  },
});

export default App;
